module.exports = __webpack_public_path__ + "media/images/emblems/Granges-Paccot-coat_of_arms-658ea3e3fa5901675f9c993b6ebbfb3d.svg";